import { formatNumber } from "@";

export const renderRotatedBarLabel =
  (data, dataKey) =>
  ({ x, y, width, height, index }) =>
    data[index][dataKey] > 0 && (
      <text
        fill="#fff"
        fontSize={10}
        fontWeight={700}
        x={x - 15 + width / 2}
        y={y + height / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        transform={`rotate(-90, ${x + width / 2}, ${y + height / 2})`}
      >
        {formatNumber(data[index][dataKey]?.toFixed(2))}%
      </text>
    );
